var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 20,
    viewBox: "0 0 6 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 3C0.25 1.48579 1.48579 0.25 3 0.25C4.51421 0.25 5.75 1.48579 5.75 3C5.75 4.51421 4.51421 5.75 3 5.75C1.48579 5.75 0.25 4.51421 0.25 3ZM3 1.75C2.31421 1.75 1.75 2.31421 1.75 3C1.75 3.68579 2.31421 4.25 3 4.25C3.68579 4.25 4.25 3.68579 4.25 3C4.25 2.31421 3.68579 1.75 3 1.75ZM0.25 10C0.25 8.48579 1.48579 7.25 3 7.25C4.51421 7.25 5.75 8.48579 5.75 10C5.75 11.5142 4.51421 12.75 3 12.75C1.48579 12.75 0.25 11.5142 0.25 10ZM3 8.75C2.31421 8.75 1.75 9.31421 1.75 10C1.75 10.6858 2.31421 11.25 3 11.25C3.68579 11.25 4.25 10.6858 4.25 10C4.25 9.31421 3.68579 8.75 3 8.75ZM0.25 17C0.25 15.4858 1.48579 14.25 3 14.25C4.51421 14.25 5.75 15.4858 5.75 17C5.75 18.5142 4.51421 19.75 3 19.75C1.48579 19.75 0.25 18.5142 0.25 17ZM3 15.75C2.31421 15.75 1.75 16.3142 1.75 17C1.75 17.6858 2.31421 18.25 3 18.25C3.68579 18.25 4.25 17.6858 4.25 17C4.25 16.3142 3.68579 15.75 3 15.75Z",
    fill: "#22282F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.63d3369d29ed4a3b6e9f18231fca69e0.svg";
export { ForwardRef as ReactComponent };